export const getFieldSx = () => ({
  mb: 2
});

export const LocationDetailsModalSx = {
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)',
    textAlign: 'left'
  },
  desc: {
    marginTop: '12px',
    marginBottom: '24px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  autoCompleteSx: {
    '& .MuiInputBase-root': {
      borderRadius: '4px',
      maxHeight: '37px',
      paddingTop: '0px'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: 'var(--font-size-14)',
    },
    '& input::placeholder': {
      //  color: 'var(--color-primary)',
      opacity: 1,
      fontSize: 'var(--font-size-14)',
    }
  },
  textFieldError: {
    color: 'var(--color-error-alt)',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    textAlign: 'left',
    marginTop: '3px',
    marginRight: '14px',
    marginBottom: 0,
    marginLeft: '14px'
  },
  showNoDataTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '6px',
    marginLeft: '14px'
  },
  showNoDataSpanTextSx: {
    color: 'var(--color-primary)',
    textDecoration: 'underline',
    textDecorationThickness: '1.2px',
    cursor: 'pointer',
    textUnderlineOffset: '4px'
  },
  serviceArea: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    color: 'var(--color-text-secondary)',
    mr: 2
  },
  formControlLabel: {
    mr: 2,
    '.MuiFormControlLabel-label': {
      fontSize: '13px',
      fontWeight: 400,
      fontColor: 'var(--color-text-light-grey)'
    }
  },
  tooltipBoxSx: { display: 'flex', alignItems: 'center', gap: '6px' }
};

/**
 * Centralized style object for Add Location form fields.
 * Use these styles in your fields/components for consistency.
 */

export const formFieldSx = {
  // Common field spacing
  fieldSpacing: {
    mb: 2
  },

  // Outlined input style to match RECOVAR look
  outlinedInput: {
    borderRadius: '0px',
    backgroundColor: 'var(--color-white)',
    fontSize: 'var(--font-size-14)',
    '& fieldset': {
      borderColor: '#C0C0C0'
    },
    '&:hover fieldset': {
      borderColor: 'var(--color-text-light-grey)'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-primary)'
    }
  },

  // Input text style
  input: {
    padding: '12px 14px'
  },

  // Label styling
  inputLabel: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    transform: 'translate(14px, 12px) scale(1)',
    '&.Mui-focused': {
      color: 'var(--color-primary)'
    },
    '&.MuiFormLabel-filled': {
      transform: 'translate(14px, -6px) scale(0.75)'
    }
  },

  // Helper text styling
  helperText: {
    fontSize: '12px',
    marginLeft: '14px',
    marginTop: '4px',
    color: 'var(--color-error-alt)'
  },

  // Submit button wrapper
  submitWrapper: {
    textAlign: 'right'
  },
  dropdownWrapper: {
    width: '100%'
  }
};

// styles.ts

export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    padding: '10px 14px',
    borderRadius: '4px',
    border: '1px solid var(--color-border)',
    maxHeight: '37px',
    '&.Mui-error': {
      borderColor: 'var(--color-error-red)' // red border on error
    },
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    }
  },
  '& input': {
    padding: 0
  }
};

export const textAreaSx = {
  '& .MuiOutlinedInput-root': {
    padding: '10px 14px',
    borderRadius: '4px',
    border: '1px solid var(--color-border)',
    minHeight: '120px', // ✅ ensure a decent textarea height
    maxHeight: '200px', // ✅ allow scrolling if content overflows
    alignItems: 'flex-start', // ✅ keep text at the top
    '&.Mui-error': {
      borderColor: 'var(--color-error-red)'
    },
    '& fieldset': {
      border: 'none'
    },
    '&:hover fieldset': {
      border: 'none'
    },
    '&.Mui-focused fieldset': {
      border: 'none'
    }
  },
  '& textarea': {
    padding: 0,
    overflow: 'auto'
  }
};

export const dropdownStyle = {
  width: '100%',
  height: '44px',
  border: '1px solid var(--color-border)',
  borderRadius: '6px',
  padding: '0 14px',
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 'var(--font-size-14)',
  lineHeight: 'var(--line-height-20)',
  color: 'var(--color-text-dark2)',
  backgroundColor: 'var(--color-white)',
  display: 'flex',
  alignItems: 'center',
  appearance: 'none'
};

export const dropdownIconSx = {
  position: 'absolute',
  right: '12px',
  top: '50%',
  transform: 'translateY(-50%)',
  pointerEvents: 'none'
};

export const helperTextSx = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: 'var(--line-height-16)',
  color: 'var(--color-error-red)',
  marginTop: '4px',
  marginLeft: '14px'
};

export const fieldSpacing = {
  mb: 2
};

export const labelTypographySx = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: 'var(--font-size-14)',
  lineHeight: 'var(--line-height-20)',
  color: 'var(--color-text-secondary)',
  marginBottom: '6px'
};
